import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = {
  key: 0,
  class: "campaign"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  class: "barcode",
  id: "barcode"
}, null, -1)
const _hoisted_4 = { class: "price-text" }
const _hoisted_5 = { class: "price" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("main", null, [
      (_ctx.isCampaign)
        ? (_openBlock(), _createElementBlock("h2", _hoisted_2, "Kampanje"))
        : _createCommentVNode("", true),
      _createElementVNode("h1", {
        class: _normalizeClass(_ctx.smallText ? 'small' : '')
      }, _toDisplayString(_ctx.product.name), 3)
    ]),
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("p", null, [
        _createTextVNode(" PRIS: "),
        _createElementVNode("span", _hoisted_5, _toDisplayString(Math.round(_ctx.priceIncMva)) + ",-", 1)
      ])
    ])
  ]))
}